import _mergeJSXProps from "babel-helper-vue-jsx-merge-props";
export default {
  name: 'Day',
  functional: true,
  render: function (h, ctx) {
    return h(
      "svg",
      _mergeJSXProps([{
        attrs: { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }
      }, ctx.data]),
      [h(
        "g",
        {
          attrs: { fill: "none", stroke: "currentColor", "stroke-width": "2", "stroke-linecap": "round", "stroke-linejoin": "round" }
        },
        [h("circle", {
          attrs: { cx: "16", cy: "16", r: "7" }
        }), h("line", {
          attrs: { x1: "16", y1: "1", x2: "16", y2: "5" }
        }), h("line", {
          attrs: { x1: "5.39", y1: "5.39", x2: "8.22", y2: "8.22" }
        }), h("line", {
          attrs: { x1: "1", y1: "16", x2: "5", y2: "16" }
        }), h("line", {
          attrs: { x1: "5.39", y1: "26.61", x2: "8.22", y2: "23.78" }
        }), h("line", {
          attrs: { x1: "16", y1: "31", x2: "16", y2: "27" }
        }), h("line", {
          attrs: { x1: "26.61", y1: "26.61", x2: "23.78", y2: "23.78" }
        }), h("line", {
          attrs: { x1: "31", y1: "16", x2: "27", y2: "16" }
        }), h("line", {
          attrs: { x1: "26.61", y1: "5.39", x2: "23.78", y2: "8.22" }
        })]
      )]
    );
  }
};